import { makeStyles } from "@mui/styles";
import { getRGBA } from "utils/color";

const useStyles = makeStyles(() => ({
  buttonBase: {
    width: "100%",
    textAlign: "left",
  },

  buttonBaseSelected: {
    width: "100%",
    textAlign: "left",
    backgroundColor: `${getRGBA("#3024E1", 0.06)}`,
    borderRadius: "0.5rem",
  },
  container: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1rem",
  },

  orgContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },

  nameAndCnpjContainer: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
  },

  orgName: {
    fontFamily: "Nunito",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    color: "#191C1A",
  },

  orgCnpj: {
    fontFamily: "Nunito",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "20px",
    color: `${getRGBA("#0F0F1E", 0.6)}`,
  },

  eSocialContainerConnected: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: `${getRGBA("#2E7D32", 0.08)}`,
    color: "#2E7D32",
    padding: "3px 10px",
    borderRadius: "100px",
  },

  eSocialContainerPending: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: `${getRGBA("#EF6C00", 0.08)}`,
    padding: "3px 10px",
    borderRadius: "100px",
  },

  eSocialPending: {
    fontFamily: "Nunito",
    lineHeight: "18px",
    fontSize: "13px",
    fontWeight: "400",
    color: "#EF6C00",
  },

  eSocialConnected: {
    fontFamily: "Nunito",
    lineHeight: "18px",
    fontSize: "13px",
    fontWeight: "400",
    color: "#2E7D32",
  },

  chipsContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },

  orgTypeContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "3px 10px",
    borderRadius: "100px",
  },

  orgType: {
    fontFamily: "Nunito",
    lineHeight: "18px",
    fontSize: "13px",
    fontWeight: "600",
  },
}));

export { useStyles };
